
<div class="bmc-package-visualizer-list"
  *ngIf="(catalogObjects && catalogObjects.length) && !isLoading">
  <div class="bmc-package-visualizer-list__head bz-space--stack-m">
    <div class="bmc-package-visualizer-list__title-search" *ngIf="isSearchMode">
      <strong class="bz-font-size--subheading">{{'DEPLOYMENT.SEARCH_RESULTS' | translate}}</strong>
      <span
        class="bz-font-size--body-small" *ngIf="catalogObjects">
          {{'DEPLOYMENT.SHOWING_RESULTS' | translate:{ "resultCount": catalogObjects.length , "filter": searchText } }}
        </span>
    </div>
    <bzg-button-secondary [size]="'s'" (click)="toggleExpandAll()">
      {{ (isExpandAll ? 'PACKAGE_VISUALIZER.COLLAPSE_ALL' : 'PACKAGE_VISUALIZER.EXPAND_ALL') | translate }}
    </bzg-button-secondary>
  </div>
  <div class="bmc-package-visualizer-list__content">
    <ul class="bmc-package-visualizer-list__categories">
      <li class="bmc-package-visualizer-list__category bz-space--stack-m" *ngFor="let category of catalogObjects">
        <div class="bmc-package-visualizer-list__category-head" (click)="toggleExpand(category.type)">
          <bzg-icon
            [nameIcon]="!(typeExpandedCatalogObject[category.type]) ? 'icon-arrow-down-table' : 'icon-arrow-up-table'"
            class="bz-space--inline-s">
          </bzg-icon>
          <div class="bmc-package-visualizer-list__header">
            <bzg-icon [nameIcon]="true ? 'icon-folder' : 'icon-summary'" class="bz-space--inline-s"></bzg-icon>
            <span class="bmc-package-visualizer-list__category-text">{{ category.type }}
              ({{category.objectList.length}})</span>
          </div>
          <div class="bmc-package-visualizer-list__filter-input" (click)="$event.stopPropagation()"
            *ngIf="!isSearchMode && typeExpandedCatalogObject[category.type]">
            <bzg-input [(ngModel)]="filterText[category.type]" class="bz-space--inline-m"
              [placeholder]="'PACKAGE_VISUALIZER.PLACEHOLDER_LIST_FILTER' | translate" actionIcnPosition="right">
              <bzg-icon nameIcon="filter"></bzg-icon>
            </bzg-input>
          </div>
        </div>
        <div class="bmc-package-visualizer-list__category-table"
          *ngIf="typeExpandedCatalogObject[category.type]">
          <table class="bz-table">
            <thead>
              <tr>
                <th class="bz-table__cell bmc-package-visualizer-list__table-header-cell">
                  {{'PACKAGE_VISUALIZER.NAME_LABEL' | translate}}
                </th>
                <th class="bz-table__cell bmc-package-visualizer-list__table-header-cell">
                  {{'PACKAGE_VISUALIZER.MODIFIED_BY_LABEL' | translate}}
                </th>
                <th class="bz-table__cell bmc-package-visualizer-list__table-header-cell">
                  {{'PACKAGE_VISUALIZER.MODIFIED_DATE_LABEL' | translate}}
                </th>
                <th class="bz-table__cell">
                  {{'PACKAGE_VISUALIZER.DEPENDENCIES_LABEL' | translate}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let catalogObject of category.objectList | searchBy : filterText[category.type] || '' : ['name', 'modifiedByUser', 'modifiedDate']" (click)="navigateTo(catalogObject)">
                <td class="bz-table__cell bmc-package-visualizer-list__table-cell">
                  <bzg-icon [nameIcon]="'icon-summary'" class="bz-space--inline-s"></bzg-icon>
                  <a
                    [ngClass]="{ 'bmc-package-visualizer-list__table-cell-text' : catalogObject.childrenGuids && catalogObject.childrenGuids.length > 0 }">
                    {{ catalogObject.name | sanitizeText}}
                  </a>
                </td>
                <td class="bz-table__cell">
                  <a
                    [ngClass]="{ 'bmc-package-visualizer-list__table-cell-text' : catalogObject.childrenGuids && catalogObject.childrenGuids.length > 0 }">
                    {{ catalogObject.modifiedByUser | sanitizeText}}
                  </a>
                </td>
                <td class="bz-table__cell">
                  <a
                    [ngClass]="{ 'bmc-package-visualizer-list__table-cell-text' : catalogObject.childrenGuids && catalogObject.childrenGuids.length > 0 }">
                    {{ catalogObject.modifiedDate | userTimezoneFormat:1 }}
                  </a>
                </td>
                <td class="bz-table__cell">
                  <bzg-icon [nameIcon]="'icon-process'" class="bmc-package-visualizer-list__diagram-icon bz-space--inline-s" style="transform: rotate(-90deg);" (click)="openDependenciesModal($event, catalogObject)">
                  </bzg-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>
    </ul>
  </div>
</div>
<div class="bmc-package-visualizer-list__loading" *ngIf="isLoading">
    <bz-loading [size]="'s'">
      {{'PACKAGE_VISUALIZER.LOADING_CATALOG_OBJECTS' | translate}}
    </bz-loading>
</div>
